import React from 'react';
import './styles.scss';
import { FaTimes } from 'react-icons/fa';
import { Modal } from 'bootstrap';
import PropTypes from 'prop-types';
import EpButton from '../EpButton';
import store from '../../redux/store';
import { hideModal, showModal } from '../../redux/actions/sessionTimeOutModalAction';

let lastAction = 'close';
let modalInstance = null;

export const handleToggleModal = (modalId, modalOptions) => {
  const modalEl = document.getElementById(modalId);
  modalInstance = Modal.getOrCreateInstance(modalEl, modalOptions);

  if (lastAction === 'close') {
    lastAction = 'open';
    modalInstance.show();
  } else if (lastAction === 'open') {
    lastAction = 'close';
    modalInstance.hide();
  }
};

export const handleToggleModalWithGlobalState = (
  modalId, modalType, modalNewVisibility, modalOptions,
) => {
  const modalEl = document.getElementById(modalId);
  const backdropElements = document.querySelectorAll('.modal-backdrop');

  if (modalNewVisibility) {
    modalInstance = Modal.getOrCreateInstance(modalEl, modalOptions);
    modalInstance.show();
    store.dispatch(showModal(modalType, modalInstance));
  } else {
    if (backdropElements) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < backdropElements.length; i++) {
        backdropElements[i].remove();
      }
    }

    modalInstance.hide();
    store.dispatch(hideModal());
  }
};

const EpModal = ({
  noHeader, headerTitle, headerContent, bodyContent, footerContent, alignFooter, size,
  modalId, modalType,
}) => (
  <div className="modal fade" id={modalId}>
    <div className={`modal-dialog modal__dialog ${size}`}>
      <div className="modal-content modal__content">
        {!noHeader
          && (
            <div className="modal-header modal__content-header">
              <h5 className="modal-title modal__content-header-title">{headerTitle}</h5>
              {headerContent || ''}

              <EpButton
                buttonIcon={<FaTimes className="btn__icon" />}
                buttonType="link-secondary"
                customClass="modal__content-header-close"
                actionType="button"
                aria-label="Close"
                linkFunc={
                  () => (
                    modalType
                      ? handleToggleModalWithGlobalState(modalId, modalType, false)
                      : handleToggleModal(modalId)
                  )
                }
                size="sm"
              />
            </div>
          )}

        <div className="modal-body modal__content-body">
          {bodyContent}
        </div>

        {footerContent
          && (
            <div className={`modal-footer modal__content-footer d-flex ${alignFooter}`}>
              {footerContent}
            </div>
          )}
      </div>
    </div>
  </div>
);
export default EpModal;

EpModal.defaultProps = {
  headerTitle: '',
  headerContent: null,
  noHeader: null,
  alignFooter: 'justify-content-between',
  modalType: null,
  size: 'md',
};

EpModal.propTypes = {
  noHeader: PropTypes.bool,
  headerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  headerContent: PropTypes.element,
  bodyContent: PropTypes.element.isRequired,
  footerContent: PropTypes.element.isRequired,
  alignFooter: PropTypes.oneOf(['justify-content-start', 'justify-content-center', 'justify-content-between', 'justify-content-end', 'justify-content-around']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  modalId: PropTypes.string.isRequired,
  modalType: PropTypes.string,
};
